import Cookies from 'universal-cookie';

export const STICKY_UTM_COOKIE_NAME = 'utm_source';
export const DEFAULT_STICKY_UTM_TTL_SECONDS = 1800;

// Parses the comma separated allowlist from configuration, 
// e.g. "SY, PARTNER_X" becomes ['SY', 'PARTNER_X']
export const parseStickyUtmSources = configValue =>
  typeof configValue === 'string'
    ? configValue.split(',').map(value => value.trim()).filter(Boolean)
    : [];

// Case insensitive because email clients may rewrite link casing
const isAllowlisted = (utmSource, stickyUtmSources) => {
  const normalized = String(utmSource || '').trim().toLowerCase();

  return stickyUtmSources.some(source => source.toLowerCase() === normalized);
};

// Writes the cookie only for allowlisted values and never throws
export const persistStickyUtmSource = (
  utmSource,
  stickyUtmSources = [],
  ttlSeconds = DEFAULT_STICKY_UTM_TTL_SECONDS
) => {
  if (typeof document === 'undefined' || !isAllowlisted(utmSource, stickyUtmSources)) {
    return false;
  }

  const ttl = Number(ttlSeconds) > 0 ? Number(ttlSeconds) : DEFAULT_STICKY_UTM_TTL_SECONDS;

  try {
    new Cookies().set(
      STICKY_UTM_COOKIE_NAME,
      // Booking requires this JSON shape with expiresAt to tell our cookie from third party ones
      JSON.stringify({
        utmSource: String(utmSource).trim(),
        expiresAt: Date.now() + ttl * 1000,
      }),
      // Host scoped on purpose, and lax so it survives the cross site navigation from the email client
      { path: '/', secure: true, sameSite: 'lax', maxAge: ttl }
    );

    return true;
  } catch (e) {
    // Private mode and blocked cookies degrade silently
    return false;
  }
};